import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/cookies")({
  head: () => ({
    meta: [
      { title: "Política de Cookies — PRICO" },
      { name: "description", content: "Cómo usa PRICO las cookies y cómo puedes gestionarlas." },
      { property: "og:title", content: "Política de Cookies — PRICO" },
      { property: "og:description", content: "Gestión de cookies en PRICO." },
      { property: "og:url", content: "/cookies" },
    ],
    links: [{ rel: "canonical", href: "/cookies" }],
  }),
  component: CookiesPage,
});

function CookiesPage() {
  return (
    <article className="container-prico py-20 max-w-3xl">
      <span className="chip">Cookies</span>
      <h1 className="text-5xl font-black mt-4">Política de Cookies</h1>
      <p className="text-muted-foreground mt-2 text-sm">Última actualización: 15 de junio de 2026</p>

      <div className="mt-10 space-y-8 text-foreground/85">
        <section>
          <h2 className="text-2xl font-black">¿Qué son las cookies?</h2>
          <p className="mt-3 leading-relaxed">
            Las cookies son pequeños archivos que se almacenan en tu dispositivo cuando visitas un
            sitio web. Sirven para recordar tus preferencias y mejorar tu experiencia.
          </p>
        </section>
        <section>
          <h2 className="text-2xl font-black">Tipos de cookies que usamos</h2>
          <ul className="mt-3 space-y-2 list-disc pl-6">
            <li><b>Esenciales:</b> necesarias para el funcionamiento del sitio (sesión, preferencias).</li>
            <li><b>Analíticas:</b> nos ayudan a entender cómo usas PRICO para mejorarlo.</li>
            <li><b>Marketing:</b> personalizan los anuncios que ves dentro y fuera del sitio.</li>
          </ul>
        </section>
        <section>
          <h2 className="text-2xl font-black">Cómo gestionarlas</h2>
          <p className="mt-3 leading-relaxed">
            Puedes aceptar o rechazar cookies desde el banner que aparece en tu primera visita.
            También puedes configurarlas desde tu navegador en cualquier momento.
          </p>
        </section>
        <section>
          <h2 className="text-2xl font-black">Contacto</h2>
          <p className="mt-3 leading-relaxed">
            Para dudas sobre nuestra política de cookies, escríbenos a
            {" "}<a className="text-primary" href="mailto:support@pricoapp.com">support@pricoapp.com</a>.
          </p>
        </section>
      </div>
    </article>
  );
}
